import React from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';

import FormInput from '../../checkout/molecules/FormInput';
import FormTitle from '../../checkout/molecules/FormTitle';
import { SOFT_TOMATO } from '../../colors';

const Container = styled.div``;

const Form = styled.div`
  // border: 1px solid red;
  diplay: flex;
  flex-direction: columm;
`;

const ErrorText = styled.span`
  color: red;
  font-size: 0.75rem;
`;

const SubmitBtn = styled.button`
  width: 100%;
  border: none;
  background-color: ${SOFT_TOMATO};
  color: white;
  border-radius: 6px;
  height: 40px;
  font-family: 'Poppins-SemiBold';
  font-size: 0.8rem;
  margin: 0.5rem 0rem;

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    color: #666;
  }
`;

interface TrackOrderFormProps {
  onTrackOrder?: (email: string, orderNumber: string) => void;
}

const TrackOrderForm = ({
  onTrackOrder
}: TrackOrderFormProps) => {

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onBlur', 
  });

  const onPressSubmit = () => {
    handleSubmit((data) => {
      onTrackOrder?.(data.email, data.orderNumber);
    })();
  }


  return (
    <>
      <Container>
        <Form>
          <FormTitle title='ORDERING INFORMATION' />
          <FormInput 
            placeholder='ORDER NUMBER' 
            type='number' 
            {...register('orderNumber', {
              required: `Field is required`.toUpperCase(),
            })}
          />
          {errors.orderNumber && <ErrorText>{errors.orderNumber.message?.toString()}</ErrorText>}

          <FormInput 
            placeholder='EMAIL ADDRESS' 
            type='email'
            {...register('email', { 
              required: `Field is required`.toUpperCase(),
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Basic email regex
                message: 'Enter a valid email address'.toUpperCase(),
              }, 
            })}
          />
          {errors.email && <ErrorText>{errors.email.message?.toString()}</ErrorText>}

          <SubmitBtn 
            onClick={onPressSubmit}
            disabled={!isValid}
          >
            CONTINUE
          </SubmitBtn>
        </Form>
      </Container>
    </>
  )
}

export default TrackOrderForm;